import foundingSourcesAvaliableModel from './foundingSourcesOptionsModel';
import yesNoModel from './yesNoModel';

const foundingSourcesModel = () => {
  return {
    sections: [
      {
        title: 'Benefits',
        rows: [
          {
            cols: [
              {
                label: 'Is this individual receiving SS benefits?',
                mapTo: 'options',
                type: 'checkbox',
                optionType: 'SSBenefits',
                inline: true,
                includeOther: true,
                otherMapTo: 'fundingSource.otherSSBenefit'
              },
            ],
          },
        ],
      },
      {
        title: 'Insurance Information',
        rows: [
          {
            cols: [
              {
                type: 'singleCheckbox',
                label: 'MA-EPD',
                mapTo: 'isMAEPD',
              },
            ],
          },
          {
            cols: [
              {
                type: 'text',
                label: 'Medicare #',
                mapTo: 'medicareNumber',
                maxLength: 50,
              },
              {
                type: 'text',
                label: 'MA/PMI#',
                mapTo: 'maPmiNumber',
                maxLength: 50,
              },
              {
                type: 'text',
                label: 'Other Insurance #',
                mapTo: 'otherInsuranceNumber',
                maxLength: 50,
              },
            ],
          },
          {
            cols: [
              {
                label: 'Is this individual receiving SNAP benefits?',
                type: 'radio',
                mapTo: 'isReceivingSnapBenefits',
                options: yesNoModel().yesNo,
                inline: true,
              },
            ],
          },
          {
            cols: [
              {
                label:
                  'Is this individual a participant of the Ticket to Work program?',
                mapTo: 'isTicketToWorkProgramParticipant',
                type: 'radio',
                options: yesNoModel().yesNo,
                inline: true,
              },
            ],
          },
          {
            cols: [
              {
                label: 'If yes, Provider Name',
                mapTo: 'ticketToWorkProgramProvider',
                type: 'text',
                maxLength: 50,
              },
            ],
          },
        ],
      },
      {
        title: 'Funding Sources',
        rows: [
          {
            cols: [
              {
                label: 'All funding sources available, check all that apply',
                type: 'checkbox',
              }
            ]
          },
          {
            cols: [
              {
                type: 'checkboxwithmodel',
                options: foundingSourcesAvaliableModel()
                  .foundingSourcesAvaliable,
                inline: true,
              },
            ],
          },
          {
            cols: [
              {
                type: 'singleCheckbox',
                label: 'ICF',
                mapTo: 'fundingSource.isIcf',
                isCollapsible: true,
                rows: [
                  {
                    cols: [
                      {
                        label: 'Provider Number',
                        mapTo: 'fundingSource.icfProviderNumber',
                        type: 'text',
                        maxLength: 100,
                        style: {
                          width: '249px'
                        }
                      },
                      {
                        label: 'Federal ID Number',
                        mapTo: 'fundingSource.icfFederalIdNumber',
                        type: 'text',
                        maxLength: 100,
                        style: {
                          width: '249px'
                        }
                      }
                    ]
                  }
                ]
              },
            ]
          },
          {
            cols: [
              {
                type: 'singleCheckbox',
                label: 'Rep Payee',
                mapTo: 'fundingSource.isRepPayee',
                isCollapsible: true,
                rows: [
                  {
                    cols: [
                      {
                        label: 'Full Name',
                        mapTo: 'fundingSource.repPayeeName',
                        type: 'text',
                        maxLength: 150,
                        style: {
                          width: '249px'
                        }
                      },
                      {
                        label: 'Address',
                        mapTo: 'fundingSource.repPayeeAddress',
                        type: 'text',
                        maxLength: 400,
                        style: {
                          width: '249px'
                        }
                      },
                    ]
                  },
                  {
                    cols: [
                      {
                        label: 'City',
                        mapTo: 'fundingSource.repPayeeCity',
                        type: 'text',
                        maxLength: 40,
                        style: {
                          width: '249px'
                        }
                      },
                      {
                        label: 'State',
                        mapTo: 'fundingSource.repPayeeState',
                        type: 'text',
                        maxLength: 2,
                        style: {
                          width: '249px'
                        }
                      },
                    ]
                  },
                  {
                    cols: [
                      {
                        label: 'Zip Code',
                        mapTo: 'fundingSource.repPayeeZipCode',
                        type: 'text',
                        maxLength: 10,
                        style: {
                          width: '249px'
                        }
                      },
                      {
                        label: 'E-mail',
                        mapTo: 'fundingSource.repPayeeEmail',
                        type: 'text',
                        required: false,
                        isInvalid: false,
                        isEmail: true,
                        maxLength: 200,
                        style: {
                          width: '249px'
                        }
                      }
                    ]
                  },
                  {
                    cols: [
                      {
                        label: 'Work Phone Number',
                        mapTo: 'fundingSource.repPayeeWorkPhoneNumber',
                        type: 'tel',
                        required: false,
                        isInvalid: false,
                        isPhoneNumber: true,
                        maxLength: 30,
                        style: {
                          width: '249px'
                        }
                      },
                      {
                        label: 'Fax Number',
                        mapTo: 'fundingSource.repPayeeFax',
                        type: 'tel',
                        required: false,
                        isInvalid: false,
                        isPhoneNumber: true,
                        maxLength: 30,
                        style: {
                          width: '249px'
                        }
                      }
                    ]
                  }
                ]
              },
            ]
          },
          {
            cols: [
              {
                type: 'singleCheckbox',
                label: 'CDCS',
                mapTo: 'fundingSource.isCdcs',
                isCollapsible: true,
                rows: [
                  {
                    cols: [
                      {
                        label: 'Full Name',
                        mapTo: 'fundingSource.cdcsName',
                        type: 'text',
                        maxLength: 150,
                        style: {
                          width: '249px'
                        }
                      },
                      {
                        label: 'Address',
                        mapTo: 'fundingSource.cdcsAddress',
                        type: 'text',
                        maxLength: 400,
                        style: {
                          width: '249px'
                        }
                      },
                    ]
                  },
                  {
                    cols: [
                      {
                        label: 'City',
                        mapTo: 'fundingSource.cdcsCity',
                        type: 'text',
                        maxLength: 40,
                        style: {
                          width: '249px'
                        }
                      },
                      {
                        label: 'State',
                        mapTo: 'fundingSource.cdcsState',
                        type: 'text',
                        maxLength: 2,
                        style: {
                          width: '249px'
                        }
                      },
                    ]
                  },
                  {
                    cols: [
                      {
                        label: 'Zip Code',
                        mapTo: 'fundingSource.cdcsZipCode',
                        type: 'text',
                        maxLength: 10,
                        style: {
                          width: '249px'
                        }
                      },
                      {
                        label: 'E-mail',
                        mapTo: 'fundingSource.cdcsEmail',
                        type: 'text',
                        required: false,
                        isInvalid: false,
                        isEmail: true,
                        maxLength: 200,
                        style: {
                          width: '249px'
                        }
                      }
                    ]
                  },
                  {
                    cols: [
                      {
                        label: 'Work Phone Number',
                        mapTo: 'fundingSource.cdcsWorkPhoneNumber',
                        type: 'tel',
                        required: false,
                        isInvalid: false,
                        isPhoneNumber: true,
                        maxLength: 30,
                        style: {
                          width: '249px'
                        }
                      },
                      {
                        label: 'Fax Number',
                        mapTo: 'fundingSource.cdcsFax',
                        type: 'tel',
                        required: false,
                        isInvalid: false,
                        isPhoneNumber: true,
                        maxLength: 30,
                        style: {
                          width: '249px'
                        }
                      }
                    ]
                  }
                ]
              },
            ]
          },
          {
            cols: [
              {
                type: 'singleCheckbox',
                label: 'Other',
                mapTo: 'fundingSource.isOther',
                isCollapsible: true,
                rows: [
                  {
                    cols: [
                      {
                        label: 'Full Name',
                        mapTo: 'fundingSource.otherName',
                        type: 'text',
                        maxLength: 150,
                        style: {
                          width: '249px'
                        }
                      },
                      {
                        label: 'Address',
                        mapTo: 'fundingSource.otherAddress',
                        type: 'text',
                        maxLength: 400,
                        style: {
                          width: '249px'
                        }
                      }
                    ]
                  },
                  {
                    cols: [
                      {
                        label: 'City',
                        mapTo: 'fundingSource.otherCity',
                        type: 'text',
                        maxLength: 40,
                        style: {
                          width: '249px'
                        }
                      },
                      {
                        label: 'State',
                        mapTo: 'fundingSource.otherState',
                        type: 'text',
                        maxLength: 2,
                        style: {
                          width: '249px'
                        }
                      },
                    ]
                  },
                  {
                    cols: [
                      {
                        label: 'Zip Code',
                        mapTo: 'fundingSource.otherZipCode',
                        type: 'text',
                        maxLength: 10,
                        style: {
                          width: '249px'
                        }
                      },
                    ]
                  }
                ]
              },
            ],
          },
        ],
      },
    ],
  };
};

export default foundingSourcesModel;